import React, { useCallback, useEffect, useState } from "react";
import { Swiper, SwiperClass, SwiperSlide } from "swiper/react";

import { Autoplay, Navigation } from "swiper/modules";
import config from "../../../util/config";
import LeadGeneration from "../../../components/LeadGeneration";
import LeadGenCtaBtn from "../../../features/lead-generation/LeadGenCtaBtn";

const mockColleges = [
  {
    collegeLogo:
      "https://cdncollegementor.blob.core.windows.net/application-addmission/Top-Colleges/woxsen.jpg",
    image:
      "https://cdncollegementor.blob.core.windows.net/application-addmission/Top-Colleges/woxsen.jpg",
    url: "www.jgu.edu.in",
  },
  {
    collegeLogo:
      "https://cdncollegementor.blob.core.windows.net/application-addmission/Top-Colleges/VIT_01.jpg",
    image:
      "https://cdncollegementor.blob.core.windows.net/application-addmission/Top-Colleges/VIT_01.jpg",
    url: "www.snu.edu.in",
  },
  {
    collegeLogo:
      "https://cdncollegementor.blob.core.windows.net/application-addmission/Top-Colleges/UPES.jpg",
    image:
      "https://cdncollegementor.blob.core.windows.net/application-addmission/Top-Colleges/UPES.jpg",
    url: "www.upes.ac.in",
  },
  {
    collegeLogo:
      "https://cdncollegementor.blob.core.windows.net/application-addmission/Top-Colleges/SSN_01.jpg",
    image:
      "https://cdncollegementor.blob.core.windows.net/application-addmission/Top-Colleges/SSN_01.jpg",
    url: "www.amity.edu/bengaluru",
  },
  {
    collegeLogo:
      "https://cdncollegementor.blob.core.windows.net/application-addmission/Top-Colleges/op-jindal-global.jpg",
    image:
      "https://cdncollegementor.blob.core.windows.net/application-addmission/Top-Colleges/op-jindal-global.jpg",
    url: "www.amity.edu/bengaluru",
  },
  {
    collegeLogo:
      "https://cdncollegementor.blob.core.windows.net/application-addmission/Top-Colleges/JAIN.jpg",
    image:
      "https://cdncollegementor.blob.core.windows.net/application-addmission/Top-Colleges/JAIN.jpg",
    url: "www.jgu.edu",
  },
];
// const mockColleges = [
//   {
//     collegeLogo: "/images/events-manav-rachann.webp",
//     image: "/images/events-manav-rachann.webp",
//     url: "www.jgu.edu.in",
//   },
//   {
//     collegeLogo: "/images/events-aditya-university.webp",
//     image: "/images/events-aditya-university.webp",
//     url: "www.jgu.edu.in",
//   },
//   {
//     collegeLogo: "/images/s-vysa-events.webp",
//     image: "/images/s-vysa-events.webp",
//     url: "www.jgu.edu.in",
//   },
//   {
//     collegeLogo: "/images/events-vishwa-vishwani.webp",
//     image: "/images/events-vishwa-vishwani.webp",
//     url: "www.jgu.edu.in",
//   },
//   {
//     collegeLogo: "/images/events-dr.mgr.webp",
//     image: "/images/events-dr.mgr.webp",
//     url: "www.jgu.edu.in",
//   },
// ];
const ScholarshipFairSponsors = () => {
  const [swiperRef, setSwiperRef] = useState<SwiperClass>();
  const [navBtnDisabled, setNavBtnDisabled] = useState({
    prev: true,
    next: false,
  });
  const [currentSlide, setCurrentSlide] = useState(0);
  const [totalSlides, setTotalSlides] = useState(0);
  const [isPrevHovered, setIsPrevHovered] = useState(false);

  useEffect(() => {
    if (swiperRef && swiperRef.slides) {
      setTotalSlides(swiperRef.slides.length);
    }
  }, [swiperRef]);

  const handleSlideChange = () => {
    if (swiperRef) {
      setCurrentSlide(swiperRef.realIndex || 0);
      setNavBtnDisabled({
        prev: swiperRef.isBeginning,
        next: swiperRef.isEnd,
      });
    }
  };

  return (
    <div
      style={{ backgroundColor: "var(--Background-8, #F7F7F7)" }}
      className="text-black relative z-10"
    >
      <div className="container pt-12 pb-6 max-sm:py-6">
        <h3 className="text-5xl max-md:text-[32px] max-md:flex max-md:flex-col max-lg:text-center font-light text-[#173CBA] capitalize">
          <span className="font-light">College Mentor</span>{" "}
          <span className="font-bold text-[#0C9]">
          Partner Universities
          </span>
        </h3>
        <div className="flex justify-center mt-8">
          <Swiper
            onSwiper={setSwiperRef}
            onSlideChange={handleSlideChange}
            spaceBetween={30}
            className="w-full"
            modules={[Autoplay, Navigation]}
            loop={true}
            autoplay={{
              delay: 1500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 30,
              },
              1280: {
                slidesPerView: 4,
                spaceBetween: 30,
              },
            }}
          >
            {mockColleges.map((college) => (
              <SwiperSlide key={college.url}>
                <div
                  className="flex flex-col gap-2 p-4 rounded-lg my-2 bg-white"
                  style={{ boxShadow: "0px 0px 4px #ccc" }}
                >
                  <img
                    src={college.image}
                    className="w-full rounded-md"
                    alt={college.url}
                  />
                  <div className="flex gap-4 items-center justify-between p-2 bg-blue rounded-md text-white">
                    <span className="truncate text-xs font-semibold">
                      {college.url}
                    </span>
                    <LeadGenCtaBtn
                      pageName="application-to-direct-admission-landing"
                      ctaName="apply-now"
                      additionalInfo={college.url}
                      className="shrink-0 text-sm font-bold py-1 px-2 bg-green rounded-md"
                    >
                      Apply Now
                    </LeadGenCtaBtn>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default ScholarshipFairSponsors;
